import React from 'react';

import api, { urlParamCharacter } from '../services/api';
import placeholder from '../images/placeholder-slideshow.png';

export default class Slideshow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      activeSlide: 1,
      delay: 3000,
      total: 0,
      isLoading: true,
    };
    this.interval = null;
    this.slideshow = this.slideshow.bind(this);
  }

  componentDidMount() {
    const { delay } = this.state;

    api.get(`/locations_slideshow${urlParamCharacter}per_page=12&page=1&orderby=menu_order&order=asc`)
      .then((response) => {
        this.setState({
          locations: response.data,
          total: parseInt(response.headers['x-wp-total'], 10),
          isLoading: false,
        });

        this.interval = setInterval(this.slideshow, delay);
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    const { delay } = this.state;

    if (prevState.delay !== delay) {
      clearInterval(this.interval);
      this.interval = setInterval(this.slideshow, delay);
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  slideshow() {
    const { activeSlide, total } = this.state;

    if (activeSlide < total) {
      this.setState({ activeSlide: activeSlide + 1 });
    } else {
      this.setState({ activeSlide: 1 });
    }
  }

  render() {
    const { locations, activeSlide, isLoading } = this.state;

    return (
      <div className="container Slideshow Slideshow--loaded">
        {isLoading ? (
          <img
            alt=""
            src={placeholder}
            className="Slideshow__image Slideshow__image--loading"
          />
        ) : (
          <ul className="Slideshow__list">
            {locations.map((location, key) => (
              <li
                // eslint-disable-next-line react/no-array-index-key
                key={key}
                className={`Slideshow__list-item ${
                  ((key + 1) === activeSlide)
                    ? 'Slideshow__list-item--active'
                    : 'Slideshow__list-item--inactive'
                }`}
              >
                <figure className="Slideshow__figure">
                  <img
                    alt={location.acf.image.alt}
                    src={location.acf.image.url}
                    className="Slideshow__image"
                  />
                  <figcaption
                    className="Slideshow__figcaption"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: location.title.rendered,
                    }}
                  />
                </figure>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
